import React from 'react';
import {
  VStack,
  Grid,
  Button,
  IconButton
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

function NumericKeypad({ onInput, onDelete, onSubmit }) {
  return (
    <VStack spacing={8}> {/* Aumentamos el espaciado */}
      <Grid templateColumns="repeat(3, 1fr)" gap={8}> {/* Aumentamos el espaciado */}
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
          <Button key={num} onClick={() => onInput(num.toString())} size="lg"> {/* Cambiamos el tamaño a 'lg' */}
            {num}
          </Button>
        ))}
        <IconButton
          aria-label="Delete"
          icon={<DeleteIcon />}
          onClick={onDelete}
          size="lg" 
        />
        <Button onClick={() => onInput('0')} size="lg">0</Button> {/* Cambiamos el tamaño a 'lg' */}
        <Button colorScheme="teal" size="lg" onClick={onSubmit}> {/* Cambiamos el tamaño a 'lg' */}
          {'>'}
        </Button>
      </Grid>
    </VStack>
  );
}

export default NumericKeypad;
